export default function PINIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.52 19.6055H8C7.38 19.6055 6.83 19.5855 6.34 19.5155C3.71 19.2255 3 17.9855 3 14.6055V9.60547C3 6.22547 3.71 4.98547 6.34 4.69547C6.83 4.62547 7.38 4.60547 8 4.60547H11.46"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5195 4.60547H16.9995C17.6195 4.60547 18.1695 4.62547 18.6595 4.69547C21.2895 4.98547 21.9995 6.22547 21.9995 9.60547V14.6055C21.9995 17.9855 21.2895 19.2255 18.6595 19.5155C18.1695 19.5855 17.6195 19.6055 16.9995 19.6055H15.5195"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 2.10547V22.1055"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5941 12.1055H11.6031"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.59412 12.1055H7.6031"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
